import React, { useMemo } from 'react';
import { RouteProps, Navigate, useLocation } from 'react-router-dom';

export type EnhancedRouteProps = Omit<RouteProps, 'element'> & {
  label?: string;
  element: React.FC | React.ReactNode;
};

const EnhancedRoute: React.FC<EnhancedRouteProps> = (props) => {
  const { element } = props;

  const isLoggedIn = localStorage.getItem('token');

  const location = useLocation();

  const finalRoute = useMemo(() => {
    if (!isLoggedIn && location.pathname !== '/login') {
      return (
        <Navigate
          to={{ pathname: '/login' }}
          state={{ from: location.pathname }}
          replace
        />
      );
    }

    if (typeof element === 'function') {
      const Component = element;

      return <Component />;
    }

    return element as React.ReactElement;
  }, [isLoggedIn, location, element]);

  return finalRoute;
};

export default EnhancedRoute;
